import { createContext } from 'react'

export interface PageContext {
  translation: Record<string, string>
  languages: any
  locale: string
  routed: boolean
  originalPath: string
}

export const PageContext = createContext<Partial<PageContext>>({})
export default PageContext